import BigNumber from 'bignumber.js'

export const TEN = new BigNumber(10)

export const toWei = (number, decimals = 18) => new BigNumber(number).times(TEN.pow(decimals))
